import { isSecureUploadSessionActive, logoutSecureUpload } from '@/api/secure-upload/secure-upload-module'
import SecureUploadHeader from '@/components/Header/SecureUploadHeader.vue'

const type = 'lead'

export const leadSecureUploadRoute = {
  path: '/secure-upload-file/:id',
  component: SecureUploadHeader,
  name: 'secure-upload-dashboard',
  meta: { type },
  props: true,
  beforeEnter: (to, from, next) => {
    // Check if secure upload session is active, else logout and redirect
    if (!isSecureUploadSessionActive()) {
      logoutSecureUpload()
      next({ name: 'secure-upload' })
      return
    }
    next()
  },
  children: [
    {
      path: 'medicare-details',
      name: 'secure-upload-medicare-details',
      component: () =>
        import(/* webpackChunkName: "SecureUploadDocuments" */ '@/components/SecureUpload/SecureUploadDashboard.vue'),
      props: (route) => ({ context: 'medicare_details', id: route.params.id }),
    },
  ],
}
